import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducer as modalReducer } from 'redux-modal'
import { history } from 'helpers/history'
import userReducer from './user'
import loaderReducer from './loader'

export const makeRootReducer = (asyncReducers) =>
  combineReducers({
    router: connectRouter(history),
    modals: modalReducer,
    user: userReducer,
    loader: loaderReducer,
    ...asyncReducers,
  })

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return
  // eslint-disable-next-line no-param-reassign
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
